(function () {
  if (window.wlyProductReady) return;
  window.wlyProductReady = true;
  var wlyRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function wlyQ(el, sel) { return el ? el.querySelector(sel) : null; }
  function wlyQA(el, sel) { return el ? Array.prototype.slice.call(el.querySelectorAll(sel)) : []; }
  function wlySectionOf(el) { return el.closest('.shopify-section'); }
  function wlyData(pdp) {
    if (pdp.wlyJson) return pdp.wlyJson;
    var tag = wlyQ(pdp, '[data-wly-pdp-json]');
    try { pdp.wlyJson = tag ? JSON.parse(tag.textContent) : null; } catch (e) { pdp.wlyJson = null; }
    return pdp.wlyJson;
  }
  function wlyState(pdp) {
    if (!pdp.wlyState) {
      var d = wlyData(pdp) || {};
      pdp.wlyState = { tier: d.defaultTier || 1, sub: false, plan: '', qty: 1, addon: false };
      var check = wlyQ(pdp, '[data-wly-pdp-sub-check]');
      if (check) pdp.wlyState.sub = check.checked;
      var plan = wlyQ(pdp, '[data-wly-pdp-sub-plan]');
      if (plan) pdp.wlyState.plan = plan.value;
    }
    return pdp.wlyState;
  }
  function wlySticky(pdp) {
    var sec = wlySectionOf(pdp);
    return sec ? wlyQ(sec, '[data-wly-pdp-sticky]') : null;
  }
  function wlyNumbers(pdp) {
    var d = wlyData(pdp);
    var s = wlyState(pdp);
    if (!d) return null;
    var sub = s.sub && d.hasPlans ? 1 : 0;
    var addon = s.addon && d.addonId ? true : false;
    var out = { sub: sub, addon: addon };
    if (d.tiersOn && d.tiers && d.tiers[s.tier - 1]) {
      var t = d.tiers[s.tier - 1];
      var m = t.m[sub];
      out.qty = t.qty;
      out.addonQty = d.addonMatch ? t.qty : 1;
      out.unit = m.u;
      out.total = addon ? m.at : m.t;
      out.pct = m.p;
      out.pctCompare = m.pc;
      out.perUnit = m.pu;
      out.label = t.label;
    } else {
      var q = Math.max(1, Math.min(s.qty, d.qty.length));
      var row = d.qty[q - 1];
      out.qty = s.qty;
      out.addonQty = d.addonMatch ? s.qty : 1;
      out.unit = d.qty[0][sub];
      out.total = row[sub + (addon ? 2 : 0)];
      out.pct = -1;
      out.pctCompare = -1;
      out.perUnit = '';
      out.label = '';
    }
    return out;
  }
  function wlyRender(pdp) {
    var d = wlyData(pdp);
    var s = wlyState(pdp);
    var n = wlyNumbers(pdp);
    if (!d || !n) return;
    wlyQA(pdp, '[data-wly-pdp-tier]').forEach(function (btn) {
      var i = parseInt(btn.getAttribute('data-wly-pdp-tier'), 10);
      var on = i === s.tier;
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      btn.classList.toggle('is-active', on);
      var t = d.tiers[i - 1];
      if (!t) return;
      var m = t.m[n.sub];
      var tot = wlyQ(btn, '[data-wly-pdp-tier-total]');
      if (tot) tot.textContent = m.t;
      var each = wlyQ(btn, '[data-wly-pdp-tier-each]');
      var wrap = btn.closest('[data-wly-pdp-tiers]');
      if (each && wrap) {
        var tpl = t.qty > 1 ? wrap.getAttribute('data-each-text') : wrap.getAttribute('data-each-single');
        each.textContent = (tpl || '').replace('[each]', m.u).replace('[save]', m.sv);
      }
    });
    wlyQA(pdp, '[data-wly-pdp-price-block]').forEach(function (box) {
      var price = wlyQ(box, '[data-wly-pdp-price]');
      if (price) price.textContent = n.unit;
      var unit = wlyQ(box, '[data-wly-pdp-unit-price]');
      if (unit && n.perUnit) unit.textContent = n.perUnit;
      var save = wlyQ(box, '[data-wly-pdp-save]');
      var mode = box.getAttribute('data-save-mode');
      if (save && mode !== 'none') {
        var pct = mode === 'compare' ? n.pctCompare : n.pct;
        if (pct > 0) {
          save.textContent = (box.getAttribute('data-save-label') || '').replace('[percent]', pct);
          save.hidden = false;
        } else if (pct === 0) {
          save.hidden = true;
        }
      }
    });
    var form = wlyQ(pdp, '[data-wly-pdp-form]');
    if (form) {
      var qIn = wlyQ(form, '[data-wly-pdp-quantity]');
      if (qIn) qIn.value = n.qty;
      var planIn = wlyQ(form, '[data-wly-pdp-plan]');
      if (planIn) {
        planIn.value = n.sub ? s.plan : '';
        planIn.disabled = !n.sub;
      }
    }
    var add = wlyQ(pdp, '[data-wly-pdp-add]');
    if (add) add.textContent = (add.getAttribute('data-label') || '').replace('[total]', n.total).trim();
    var addonBtn = wlyQ(pdp, '[data-wly-pdp-addon-add]');
    if (addonBtn && d.tiersOn && d.tiers[s.tier - 1]) {
      addonBtn.textContent = (addonBtn.getAttribute('data-label') || '').replace('[total]', d.tiers[s.tier - 1].m[n.sub].at).trim();
    } else if (addonBtn) {
      var qr = d.qty[Math.max(0, Math.min(s.qty, d.qty.length) - 1)];
      addonBtn.textContent = (addonBtn.getAttribute('data-label') || '').replace('[total]', qr[n.sub + 2]).trim();
    }
    wlyQA(pdp, '[data-wly-pdp-qty]').forEach(function (box) {
      var input = wlyQ(box, '[data-wly-pdp-qty-input]');
      if (input && parseInt(input.value, 10) !== s.qty) input.value = s.qty;
      var minus = wlyQ(box, '[data-wly-pdp-qty-minus]');
      var plus = wlyQ(box, '[data-wly-pdp-qty-plus]');
      var max = input ? parseInt(input.getAttribute('max'), 10) || 99 : 99;
      if (minus) minus.disabled = s.qty <= 1;
      if (plus) plus.disabled = s.qty >= max;
      var note = wlyQ(box, '[data-wly-pdp-qty-note]');
      var units = parseInt(box.getAttribute('data-units'), 10) || 0;
      if (note && box.getAttribute('data-note')) note.textContent = box.getAttribute('data-note').replace('[units]', units * s.qty);
    });
    wlyQA(pdp, '[data-wly-pdp-addon]').forEach(function (ab) {
      ab.classList.toggle('is-on', !!n.addon);
      var ap = wlyQ(ab, '[data-wly-pdp-addon-price]');
      if (ap && d.tiersOn && d.tiers[s.tier - 1]) ap.textContent = '+' + d.tiers[s.tier - 1].m[n.sub].ap;
    });
    var sub = wlyQ(pdp, '[data-wly-pdp-sub]');
    if (sub) sub.classList.toggle('is-on', !!n.sub);
    wlyQA(document, '[data-wly-total-label]').forEach(function (el) {
      el.textContent = el.getAttribute('data-wly-total-label').replace('[total]', n.total).trim();
    });
    var sticky = wlySticky(pdp);
    if (sticky) {
      var sAdd = wlyQ(sticky, '[data-wly-pdp-sticky-add]');
      if (sAdd) sAdd.textContent = (sAdd.getAttribute('data-label') || '').replace('[total]', n.total).trim();
      var line = wlyQ(sticky, '[data-wly-pdp-sticky-line]');
      if (line) {
        var parts = [];
        if (d.variantLine) parts.push(d.variantLine);
        if (d.tiersOn && n.label) parts.push(n.label);
        if (!d.tiersOn) parts.push('Qty ' + s.qty);
        if (n.sub) parts.push(line.getAttribute('data-sub') || 'Subscribe');
        parts.push(n.total);
        line.textContent = parts.join(' · ');
      }
    }
  }
  function wlyGallery(pdp) {
    wlyQA(pdp, '[data-wly-pg]').forEach(function (g) {
      if (g.wlyReady) return;
      g.wlyReady = true;
      var track = wlyQ(g, '[data-wly-pg-track]');
      if (!track) return;
      var slides = wlyQA(track, '[data-wly-pg-slide]');
      var count = wlyQ(g, '[data-wly-pg-count]');
      var thumbs = wlyQA(g, '[data-wly-pg-thumb]');
      var prev = wlyQ(g, '[data-wly-pg-prev]');
      var next = wlyQ(g, '[data-wly-pg-next]');
      var current = 0;
      function go(i) {
        if (!slides.length) return;
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      function mark(i) {
        current = i;
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
        thumbs.forEach(function (t) {
          var on = parseInt(t.getAttribute('data-wly-pg-thumb'), 10) === i;
          t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        if (prev) prev.disabled = slides.length < 2;
        if (next) next.disabled = slides.length < 2;
        if (strip && tlist) {
          var at = wlyQ(tlist, '[data-wly-pg-thumb="' + i + '"]');
          if (at) {
            var li = at.parentNode;
            var l = li.offsetLeft - tlist.offsetLeft;
            if (l < tlist.scrollLeft || l + li.offsetWidth > tlist.scrollLeft + tlist.clientWidth) tlist.scrollLeft = l;
          }
        }
      }
      var strip = wlyQ(g, '[data-wly-pg-strip]');
      var tlist = wlyQ(g, '[data-wly-pg-thumbs]');
      var tprev = wlyQ(g, '[data-wly-pg-tprev]');
      var tnext = wlyQ(g, '[data-wly-pg-tnext]');
      function stripState() {
        if (!strip || !tlist) return;
        var over = tlist.scrollWidth > tlist.clientWidth + 2;
        strip.classList.toggle('is-scroll', over);
        if (tprev) tprev.disabled = tlist.scrollLeft <= 2;
        if (tnext) tnext.disabled = tlist.scrollLeft + tlist.clientWidth >= tlist.scrollWidth - 2;
      }
      if (tlist) {
        tlist.addEventListener('scroll', stripState, { passive: true });
        window.addEventListener('resize', stripState);
        if (tprev) tprev.addEventListener('click', function () { tlist.scrollLeft -= tlist.clientWidth; });
        if (tnext) tnext.addEventListener('click', function () { tlist.scrollLeft += tlist.clientWidth; });
      }
      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          raf = 0;
          var w = track.clientWidth || 1;
          mark(Math.round(track.scrollLeft / w));
        });
      }, { passive: true });
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-wly-pg-thumb'), 10)); });
      });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      });
      mark(0);
      stripState();
    });
  }
  function wlyWatchSticky(pdp) {
    var sticky = wlySticky(pdp);
    var add = wlyQ(pdp, '[data-wly-pdp-add]');
    if (!sticky || !add || !('IntersectionObserver' in window)) return;
    if (pdp.wlyObserver) pdp.wlyObserver.disconnect();
    pdp.wlyObserver = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      var root = document.documentElement;
      if (show) root.style.setProperty('--wly-pdp-st-h', sticky.offsetHeight + 'px');
      root.classList.toggle('wly-pdp-st-on', show && getComputedStyle(sticky).display !== 'none');
      var b = wlyQ(sticky, '[data-wly-pdp-sticky-add]');
      if (b) b.tabIndex = show ? 0 : -1;
    });
    pdp.wlyObserver.observe(add);
  }
  function wlyInit(pdp) {
    if (!wlyData(pdp)) return;
    wlyGallery(pdp);
    wlyRender(pdp);
    wlyWatchSticky(pdp);
  }
  function wlyAll() { wlyQA(document, '[data-wly-pdp]').forEach(wlyInit); }
  function wlyRefreshIds(pdp) {
    var ids = [pdp.getAttribute('data-section-id')];
    wlyQA(document, '[data-wly-variant-refresh]').forEach(function (el) {
      var sec = wlySectionOf(el);
      if (!sec) return;
      var id = sec.id.replace('shopify-section-', '');
      if (ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }
  function wlySwapVariant(pdp, variantId, href) {
    if (pdp.wlyBusy) return;
    pdp.wlyBusy = true;
    pdp.setAttribute('aria-busy', 'true');
    var keep = wlyState(pdp);
    var ids = wlyRefreshIds(pdp);
    var base = (pdp.getAttribute('data-url') || window.location.pathname) + '?variant=' + variantId;
    var view = new URLSearchParams(window.location.search).get('view');
    if (view) base += '&view=' + encodeURIComponent(view);
    var batches = [];
    for (var b = 0; b < ids.length; b += 5) batches.push(ids.slice(b, b + 5));
    Promise.all(batches.map(function (group) {
      return fetch(base + '&sections=' + group.join(',')).then(function (r) {
        if (!r.ok) throw new Error('status ' + r.status);
        return r.json();
      });
    })).then(function (parts) {
      var json = {};
      parts.forEach(function (part) {
        for (var k in part) json[k] = part[k];
      });
      var mainId = pdp.getAttribute('data-section-id');
      ids.forEach(function (id) {
        var html = json[id];
        var sec = document.getElementById('shopify-section-' + id);
        if (!html || !sec) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('shopify-section-' + id);
        if (fresh) sec.innerHTML = fresh.innerHTML;
      });
      var main = document.getElementById('shopify-section-' + mainId);
      var next = main ? wlyQ(main, '[data-wly-pdp]') : null;
      if (next) {
        var st = wlyState(next);
        st.tier = keep.tier;
        st.qty = keep.qty;
        st.addon = keep.addon;
        var check = wlyQ(next, '[data-wly-pdp-sub-check]');
        var d = wlyData(next);
        if (check && d && d.hasPlans) {
          check.checked = keep.sub;
          st.sub = keep.sub;
        } else {
          st.sub = false;
        }
        var ac = wlyQ(next, '[data-wly-pdp-addon-check]');
        if (ac) {
          ac.checked = keep.addon && !ac.disabled;
          st.addon = ac.checked;
        }
        wlyInit(next);
      }
      var u = new URL(href || window.location.href, window.location.origin);
      var cur = new URL(window.location.href);
      cur.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', cur.pathname + cur.search + cur.hash);
      document.dispatchEvent(new CustomEvent('wly:variant:change', { detail: { variantId: variantId, url: u.href } }));
    }).catch(function () {
      window.location.href = href;
    }).then(function () {
      pdp.wlyBusy = false;
      pdp.removeAttribute('aria-busy');
    });
  }
  function wlyShowError(pdp, msg) {
    var err = wlyQ(pdp, '[data-wly-pdp-error]');
    if (!err) return;
    if (msg === false) {
      err.textContent = '';
      err.hidden = true;
      return;
    }
    err.textContent = msg || err.getAttribute('data-message') || '';
    err.hidden = !err.textContent;
  }
  function wlyAdd(pdp, withAddon, btn, toCheckout) {
    var d = wlyData(pdp);
    var s = wlyState(pdp);
    var n = wlyNumbers(pdp);
    var form = wlyQ(pdp, '[data-wly-pdp-form]');
    if (!d || !n || !form) return;
    var idIn = wlyQ(form, '[data-wly-pdp-id]');
    var item = { id: parseInt(idIn ? idIn.value : d.variantId, 10), quantity: n.qty };
    if (n.sub && s.plan) item.selling_plan = parseInt(s.plan, 10);
    var mainAdd = wlyQ(pdp, '[data-wly-pdp-add]');
    var preName = mainAdd ? mainAdd.getAttribute('data-preorder-name') : '';
    if (preName) {
      item.properties = {};
      item.properties[preName] = mainAdd.getAttribute('data-preorder-value') || 'Pre-order';
    }
    var items = [item];
    if ((withAddon || n.addon) && d.addonId) items.push({ id: d.addonId, quantity: n.addonQty });
    var buttons = [btn, mainAdd, wlyQ(pdp, '[data-wly-pdp-buy]')];
    var sticky = wlySticky(pdp);
    if (sticky) buttons.push(wlyQ(sticky, '[data-wly-pdp-sticky-add]'));
    buttons.forEach(function (b) { if (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); } });
    wlyShowError(pdp, false);
    fetch(wlyRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
      wlyOwn: true
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || '');
        return j;
      });
    }).then(function (j) {
      document.dispatchEvent(new CustomEvent('theme:cart::added', { detail: { data: j } }));
      if (toCheckout) {
        window.location.href = wlyRoot + 'checkout';
        return;
      }
      if (window.wlyCart && window.wlyCart.refresh) return window.wlyCart.refresh({ open: true });
      window.location.href = wlyRoot + 'cart';
    }).catch(function (e) {
      wlyShowError(pdp, e && e.message ? e.message : '');
    }).then(function () {
      buttons.forEach(function (b) { if (b) { b.disabled = false; b.removeAttribute('aria-busy'); } });
    });
  }
  function wlyPdpOf(el) {
    var pdp = el.closest('[data-wly-pdp]');
    if (pdp) return pdp;
    var sticky = el.closest('[data-wly-pdp-sticky]');
    if (sticky) {
      var sec = wlySectionOf(sticky);
      return sec ? wlyQ(sec, '[data-wly-pdp]') : null;
    }
    return wlyQ(document, '[data-wly-pdp]');
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var v = t.closest('[data-wly-pdp] a[data-wly-pdp-variant]');
    if (v) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      if (v.classList.contains('is-active')) return;
      wlySwapVariant(v.closest('[data-wly-pdp]'), v.getAttribute('data-wly-pdp-variant'), v.href);
      return;
    }
    var tier = t.closest('[data-wly-pdp-tier]');
    if (tier && !tier.disabled) {
      var p1 = wlyPdpOf(tier);
      wlyState(p1).tier = parseInt(tier.getAttribute('data-wly-pdp-tier'), 10);
      wlyRender(p1);
      return;
    }
    var minus = t.closest('[data-wly-pdp-qty-minus]');
    var plus = t.closest('[data-wly-pdp-qty-plus]');
    if (minus || plus) {
      var p3 = wlyPdpOf(minus || plus);
      var st = wlyState(p3);
      var input = wlyQ((minus || plus).closest('[data-wly-pdp-qty]'), '[data-wly-pdp-qty-input]');
      var max = input ? parseInt(input.getAttribute('max'), 10) || 99 : 99;
      st.qty = Math.max(1, Math.min(max, st.qty + (plus ? 1 : -1)));
      wlyRender(p3);
      return;
    }
    var addonAdd = t.closest('[data-wly-pdp-addon-add]');
    if (addonAdd) {
      e.preventDefault();
      wlyAdd(wlyPdpOf(addonAdd), true, addonAdd);
      return;
    }
    var buyNow = t.closest('[data-wly-pdp-buy]');
    if (buyNow) {
      e.preventDefault();
      wlyAdd(wlyPdpOf(buyNow), false, buyNow, true);
      return;
    }
    var stickyAdd = t.closest('[data-wly-pdp-sticky-add]');
    if (stickyAdd) {
      e.preventDefault();
      wlyAdd(wlyPdpOf(stickyAdd), false, stickyAdd);
    }
  });
  document.addEventListener('click', function (e) {
    var jump = e.target.closest('a[href^="#wly-tier-"], a[href="#wly-buy"]');
    if (!jump || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var p2 = wlyQ(document, '[data-wly-pdp]');
    if (!p2) return;
    e.preventDefault();
    var k = parseInt(jump.getAttribute('href').replace('#wly-tier-', ''), 10);
    var d2 = wlyData(p2);
    if (!isNaN(k) && d2 && d2.tiers && d2.tiers[k - 1] && d2.tiers[k - 1].ok) wlyState(p2).tier = k;
    wlyRender(p2);
    var top = p2.getBoundingClientRect().top + window.pageYOffset - 80;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: still ? 'auto' : 'smooth' });
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    var pdp = t.closest('[data-wly-pdp]');
    if (!pdp) return;
    var st = wlyState(pdp);
    if (t.matches('[data-wly-pdp-sub-check]')) {
      st.sub = t.checked;
      var plan = wlyQ(pdp, '[data-wly-pdp-sub-plan]');
      if (plan) st.plan = plan.value;
    } else if (t.matches('[data-wly-pdp-sub-plan]')) {
      st.plan = t.value;
      if (!st.sub) {
        st.sub = true;
        var c = wlyQ(pdp, '[data-wly-pdp-sub-check]');
        if (c) c.checked = true;
      }
    } else if (t.matches('[data-wly-pdp-addon-check]')) {
      st.addon = t.checked;
    } else if (t.matches('[data-wly-pdp-qty-input]')) {
      var max = parseInt(t.getAttribute('max'), 10) || 99;
      var val = parseInt(t.value, 10);
      st.qty = isNaN(val) ? 1 : Math.max(1, Math.min(max, val));
    } else {
      return;
    }
    wlyRender(pdp);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-wly-pdp-form]');
    if (!form) return;
    e.preventDefault();
    wlyAdd(form.closest('[data-wly-pdp]'), false, wlyQ(form, '[data-wly-pdp-add]'));
  });
  document.addEventListener('shopify:section:load', function (e) {
    var pdp = wlyQ(e.target, '[data-wly-pdp]');
    if (pdp) wlyInit(pdp);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wlyAll); else wlyAll();
})();
